export default __webpack_public_path__ + "static/media/create512.a9a40673.png";